/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'weight': {
    width: 32,
    height: 17,
    viewBox: '0 0 32 17',
    data: '<path pid="0" d="M28.92 3.998v-1.14c0-1.306-1.083-2.376-2.42-2.376h-1.92c-1.337 0-2.42 1.07-2.42 2.377V6.05H9.264V2.859c0-1.307-1.083-2.377-2.42-2.377h-1.92c-1.337 0-2.42 1.07-2.42 2.377v1.139C1.127 3.998 0 5.098 0 6.455v4.197c0 1.357 1.19 2.456 2.504 2.456v1.139c0 1.307 1.084 2.389 2.42 2.389h1.921c1.337 0 2.42-1.082 2.42-2.39v-3.179H22.16v3.18c0 1.307 1.084 2.389 2.42 2.389h1.922c1.335 0 2.42-1.082 2.42-2.39v-1.138c1.376 0 2.504-1.1 2.504-2.456V6.455c-.002-1.358-1.192-2.457-2.506-2.457z" _fill="#000" fill-rule="nonzero" opacity=".06"/>'
  }
})
